import React from 'react';
import { message } from 'antd';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';
import CloseIcon from 'components/Icons/CloseIcon';
import { RECORD_SOURCE_MESSAGE_KEY } from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/DetailsTab/components/RecordSourceButton/constants/messageKey';
import { OperationType } from 'components/RecordsListView/constants';

interface MessageContentProps {
  type?: OperationType;
  onReturn: () => void;
  label?: string;
  returnLabel?: string;
}

const MessageContent: React.FC<MessageContentProps> = ({
  type = OperationType.APPLICATION,
  onReturn,
  label = 'Viewing record source.',
  returnLabel
}) => {
  const onClose = () => {
    message.destroy(RECORD_SOURCE_MESSAGE_KEY);
  };

  const onReturnClick = () => {
    message.destroy(RECORD_SOURCE_MESSAGE_KEY);
    onReturn();
  };

  const resolvedReturnLabel =
    returnLabel ??
    `Return to ${
      type === OperationType.APPLICATION ? 'Application' : 'Work Order'
    }`;

  return (
    <div className="flex items-center gap-4">
      <div className="text-sm font-medium">{label}</div>
      <div className="flex items-center bg-neutral-90">
        <Button
          size="small"
          ghost
          type={ButtonType.success}
          onClick={onReturnClick}
        >
          {resolvedReturnLabel}
        </Button>
      </div>
      <button aria-label="Close" type="button" onClick={onClose}>
        <CloseIcon fill="#fff" />
      </button>
    </div>
  );
};

export default MessageContent;
